// src/App.js
import './App.css';
import { Route, Routes } from 'react-router-dom';
import Home from './components/Home/Home';
import AboutUs from './components/AboutUs/AboutUs';
import ServiceDetail from './components/ServiceDetail/ServiceDetail';
import Contact from './components/Contact/Contact';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';
import FloatingButtons from './components/FloatingButtons/FloatingButtons';
import Blog from './components/Blog/Blog';
import BlogDetail from './components/BlogDetail/BlogDetail';

function App() {
  return (
    <>
      <ScrollToTop /> 
      <FloatingButtons /> 
      
      <Routes>
        {/* Ana Sayfa ve Ön Yüz Rotaları */}
        <Route path='/' element={<Home/>} />
        <Route path='/hakkimizda' element={<AboutUs/>} />
        <Route path='/calisma-alanlari/:id' element={<ServiceDetail/>} />
        <Route path='/iletisim' element={<Contact/>} />
        
        {/* Firebase'den çekilen blogların listeleneceği Blog Sayfası */}
        <Route path='/blog' element={<Blog/>} />
<Route path='/blog/:id' element={<BlogDetail/>} /> {/* <--- BU ROTA ŞART */}      </Routes>
    </>
  );
}

export default App;